import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
import { GlobeStage } from '../globe/GlobeStage';
import { LocaleProvider, type Locale } from '../i18n/locale';
import { SITE } from '../content/site';
import { StageProvider } from '../stage/Stage';
import { Hero } from './Hero';
import { Threads } from './Threads';
import { Need } from './Need';
import { Supply } from './Supply';
import { Process } from './Process';
import { Sourcing } from './Sourcing';
import { Economics } from './Economics';
import { Journey } from './Journey';
import { Industries } from './Industries';
import { Visibility } from './Visibility';
import { Close } from './Close';
import { StickyCta } from './StickyCta';
import './home.css';

/**
 * The one public HOME, rendered per locale from shared structure + localized content:
 * the globe → many threads become one operation → tell us what you need → COLESCOMEX SUPPLY and
 * how we operate (kit product shots) → control at origin → total economics → origin to Colombia
 * on the globe → industries → visibility → what does your company need to purchase?
 */
export function Home({ locale }: { locale: Locale }) {
  return (
    <LocaleProvider locale={locale} page="home">
      <StageProvider>
        <a className="skip-link" href="#contenido">{SITE[locale].skip}</a>
        <SiteHeader />
        <GlobeStage />
        <main id="contenido" tabIndex={-1} className="home">
          <Hero />
          <Threads />
          <Need />
          <Supply />
          <Process />
          <Sourcing />
          <Economics />
          <Journey />
          <Industries />
          <Visibility />
          <Close />
        </main>
        <SiteFooter />
        <StickyCta />
      </StageProvider>
    </LocaleProvider>
  );
}
